import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner, FormLabel, Row, Col, FormControl, Card } from "react-bootstrap";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

interface PedidoItem {
  modelo: string;
  descricao?: string;
  qtd_total?: number;
  preco?: number;
  total?: number;
  grade?: Record<string, number>; // <- Define que grade é um objeto com chaves string e valores number
}

interface ItemData {
  id_pedido: any;
  id_produto: any;
  tamanhos: { tamanho: string, ord: any, preco_unitario: number, quantidade: number, }[];
}

interface ModalProps {
  show: boolean;
  setShow: any;
  tabela: any;
  data: PedidoItem;
  reload: any;
  onCancel: () => void;
}

const ModalPedidoItem: React.FC<ModalProps> = ({ show, setShow, onCancel, data, reload, tabela }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const [dataTamanhos, setDataTamanhos] = useState<{ tamanho: string; preco_venda: string }[]>([]);
  const [itemData, setItemData] = useState<ItemData>({
    id_pedido: id,
    id_produto: '',
    tamanhos: []
  });

  const handleChange = (e: React.ChangeEvent<any>, index: number) => {
    const { id, value } = e.target;

    setItemData((prevData: any) => {
      const newTamanhos = [...prevData.tamanhos];
      const existingIndex = newTamanhos.findIndex(t => t.tamanho === id);

      if (existingIndex !== -1) {
        newTamanhos[existingIndex] = { ...newTamanhos[existingIndex], quantidade: Number(value) };
      } else {
        const precoUnitario = dataTamanhos?.find(p => p.tamanho === id)?.preco_venda || 0;
        newTamanhos.push({ tamanho: id, ord: index, preco_unitario: Number(precoUnitario), quantidade: Number(value) });
      }
      const updatedData = { ...prevData, tamanhos: newTamanhos };
      console.log("itemData atualizado:", updatedData);
      return updatedData;
    });
  };

  const getData = () => {
    setLoading(true);
    api.get(`${BackEndRoutes.routes.PRODUTOS.LIST}?id_tabela=${tabela}&modelo=${data.modelo}`)
      .then((response) => {
        console.log("Resposta da API:", response.data);
        setItemData((prevData: any) => ({
          ...prevData,
          id_produto: response.data[0].id_produto
        }))
        if (response.data && response.data.length > 0) {
          setDataTamanhos(response.data[0].precos || []); // <-- Pegando tamanhos corretamente
        } else {
          setDataTamanhos([]);
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar o pedido", error);
        toast.error("Falha ao buscar pedido. Por favor, tente novamente.");
        setDataTamanhos([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSave = () => {
    setLoading(true);

    api.put(`${BackEndRoutes.routes.PEDIDOS.ITENS.UPDATE}?id_pedido=${itemData.id_pedido}&id_produto=${itemData.id_produto}`, itemData)
      .then(response => {
        console.log("Sucesso:", response.data);
        toast.success("Produto adicionado com sucesso!");
      })
      .catch(error => {
        console.error("Erro ao salvar o item", error);
        toast.error("Falha ao salvar item. Por favor, tente novamente.");
      })
      .finally(() => {
        setLoading(false);
        setShow(false);
        setItemData({
          id_pedido: id,
          id_produto: '',
          tamanhos: []
        });
        setDataTamanhos([]); // Reseta também os tamanhos disponíveis
        reload();
      });
  };

  const showOff = (
    <>
      {itemData.tamanhos.map((item, index) => {
        if (item.quantidade === 0) return null; // Oculta itens com quantidade 0

        return (
          <Col lg={4} md={6} xs={12} key={index} className="mb-3">
            <Card className="text-center" style={{ background: "#3490dc", color: "white" }}>
              <Card.Header>
                <Card.Title>Tamanho {item.tamanho}</Card.Title>
              </Card.Header>
              <Card.Body>
                <FormControl
                  id={item.tamanho}
                  type="text"
                  className="col-12 text-center form-control"
                  onChange={(e) => handleChange(e, index)}
                  value={item.quantidade}
                />
              </Card.Body>
              <Card.Footer>
                <Card.Text>R$ </Card.Text> {/* Se precisar do preço, pode ser atualizado aqui */}
              </Card.Footer>
            </Card>
          </Col>
        );
      })}
    </>
  );


  const showOn = (
    <>
      {Array.isArray(dataTamanhos) && dataTamanhos.length > 0 ? (
        dataTamanhos.map((item, index) => {
          const tamanho = item.tamanho;
          const tamanhoItem = itemData.tamanhos.find(t => t.tamanho === tamanho);
          const quantidade = tamanhoItem ? tamanhoItem.quantidade : 0; // Agora pega corretamente a quantidade

          return (
            <Col lg={4} md={6} xs={12} key={index} className="mb-3">
              <Card className="text-center" style={{ background: "#3490dc", color: "white" }}>
                <Card.Header>
                  <Card.Title>Tamanho {tamanho}</Card.Title>
                </Card.Header>
                <Card.Body>
                  <FormControl
                    id={tamanho}
                    type="text"
                    className="col-12 text-center form-control"
                    onChange={(e) => handleChange(e, index)}
                    value={quantidade}
                  />
                </Card.Body>
                <Card.Footer>
                  <Card.Text>R$ {item.preco_venda}</Card.Text>
                </Card.Footer>
              </Card>
            </Col>
          );
        })
      ) : <></>}
    </>
  );

  const tamanhoLabels: Record<string, string> = {
    "56": "PP",
    "58": "P",
    "60": "M",
    "62": "G",
    "64": "GG",
    "66": "XG",
    "68": "XGG",
  };

  useEffect(() => {
    if (data?.grade) {
      const novosTamanhos = Object.entries(data.grade)
        .filter(([_, qtd]) => Number(qtd) > 0) // Filtra apenas tamanhos com quantidade > 0
        .map(([tamanho, qtd], index) => ({
          tamanho: tamanhoLabels[tamanho] || tamanho, // Converte para label, se existir
          ord: index,
          preco_unitario: 0, // Pode ser atualizado depois se necessário
          quantidade: Number(qtd),
        }));

      setItemData((prev) => ({
        ...prev,
        tamanhos: novosTamanhos,
      }));
    }

    if (!show) {
      setItemData({
        id_pedido: id,
        id_produto: '',
        tamanhos: []
      });
      setDataTamanhos([]); // Reseta também os tamanhos disponíveis
    }
  }, [data, show, id]);

  return (
    <Modal show={show} size="xl" onHide={onCancel}>
      <Modal.Header closeButton style={{ background: "var(--color-profile-1)", color: "black" }}>
        <Modal.Title>Itens</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="d-flex align-items-center justify-content-center">
          <Col lg={6} md={6} xs={12} className="mt-3">
            <FormLabel>REFERÊNCIA</FormLabel>
            <FormControl type="text" disabled value={data?.modelo ?? "-"} />
          </Col>
          <Col lg={6} md={6} xs={12} className="mt-3">
            <FormLabel>DESCRIÇÃO</FormLabel>
            <FormControl type="text" disabled value={data?.descricao ?? "-"} />
          </Col>
          <Col lg={4} md={6} xs={12} className="mt-3">
            <FormLabel>qtd.</FormLabel>
            <FormControl type="text" disabled value={data?.qtd_total ?? "-"} />
          </Col>
          <Col lg={4} md={6} xs={12} className="mt-3">
            <FormLabel>UNIT.</FormLabel>
            <FormControl type="text" disabled value={data?.preco ?? "-"} />
          </Col>
          <Col lg={4} md={6} xs={12} className="mt-3">
            <FormLabel>TOTAL.</FormLabel>
            <FormControl type="text" disabled value={data?.total ?? "-"} />
          </Col>
        </Row>

        <Row className="mt-4">
          {dataTamanhos.length == 0
            ?
            showOff

            :
            showOn
          }
        </Row>

        <div className="d-flex justify-content-center">
          <Button onClick={getData} className="col-12">Adicionar Produto</Button>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ background: "var(--color-profile-1)" }}>
        <Button
          variant="secondary"
          size="sm"
          disabled={loading}
          onClick={onCancel}
          style={{ display: "flex", alignItems: "center" }}
        >
          {loading ? <Spinner as="span" animation="border" size="sm" /> :
            <>
              <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: "4px" }} /> Voltar
            </>
          }
        </Button>
        <Button
          variant="primary"
          size="sm"
          disabled={loading}
          onClick={handleSave}
          style={{ display: "flex", alignItems: "center" }}
        >
          {loading ? <Spinner as="span" animation="border" size="sm" /> :
            <>
              <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: "4px" }} /> Salvar
            </>
          }
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalPedidoItem;
